import { makeStyles, Typography } from "@material-ui/core"
import { FC } from "react"
import { useLocation, useParams } from "react-router-dom"
import { useNavigation } from "../../hooks/useNavigation"
import { useSession } from "../../hooks/useSession"
import { useUser } from "../../hooks/useUser"
import { colors } from "../../utils/theme"
import ChevronLeftIcon from "../atoms/ChevronLeftIcon"
import { HeaderHeight } from "../molecules/Header"
import PractitionerClientTable from "../molecules/PractitionerClientTable"

const useStyles = makeStyles((theme) => ({
  myClients: {
    padding: theme.spacing(3),
    paddingTop: HeaderHeight + theme.spacing(3),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    backgroundColor: colors.neutral.white,
    flex: 1,
  },
  content: {
    maxWidth: 1440,
    margin: "0 auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  title: {
    marginRight: theme.spacing(2),
  },
  addClientButton: {
    width: 188,
  },
  navigation: {
    height: 92,
    width: "fit-content",
    display: "flex",
    alignItems: "center",
    padding: 0,
    margin: 0,
    border: 0,
    backgroundColor: "transparent",
    cursor: "pointer",
    outline: "none",
  },
  chevron: {
    marginLeft: 4,
  },
}))

interface Params {
  id: string
}

const MyPractitionerClients: FC = () => {
  const classes = useStyles()
  const { user } = useUser()

  const params: Params = useParams()
  const { toPractitioners } = useNavigation()
  const { session } = useSession()
  let userOrgId = "none"
  if (user?.organizations) {
    userOrgId = `${user?.organizations[0].id}-${user?.organizations[0].name}`
  }

  const location = useLocation<{ name: string }>()
  const superviseeName = location.state?.name // supervisees name passed in from previous page
  return (
    <>
      <div className={classes.myClients}>
        <div className={classes.content}>
          <div className={classes.header}>
            <button className={classes.navigation} onClick={toPractitioners}>
              <ChevronLeftIcon className={classes.chevron} />
              <Typography variant="h3" className={classes.title}>
                Clients of {superviseeName}
              </Typography>
            </button>
          </div>
          <PractitionerClientTable id={params?.id ?? session?.userId ?? ""} />
        </div>
      </div>
    </>
  )
}

export default MyPractitionerClients
